/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />

import { CISAddressTypeAhead } from "../../common/CISAddressTypeAhead";

export class RebateEligibilitySearchFieldBinder {

    public static Init() {

        RebateEligibilitySearchFieldBinder.BindHandlers();
        RebateEligibilitySearchFieldBinder.ShowHideCustomerLookupFields($("#ApplicationInformation_EligibilityInfo_EligibilityCheckTypeId").val());

        let url: string = `${window.location.origin}/api/Eligibility/TypeaheadAddress`;
        var cisTypeahead: CISAddressTypeAhead = new CISAddressTypeAhead(url);
        cisTypeahead.Setup("ApplicationInformation_EligibilityInfo_TypeaheadAddress", "ApplicationInformation_EligibilityInfo_MelissaAddressKey", "ApplicationInformation_EligibilityInfo_UnitNumber");

        CISAddressTypeAhead.InitTypeaheadFieldName();
    }

    private static BindHandlers() {
        $("#ApplicationInformation_EligibilityInfo_EligibilityCheckTypeId").on("change", function () {
            RebateEligibilitySearchFieldBinder.ShowHideCustomerLookupFields($("#ApplicationInformation_EligibilityInfo_EligibilityCheckTypeId").val());
            RebateEligibilitySearchFieldBinder.ResetInputs();

            var e = new Event('icf-eligibility-deselected');
            document.dispatchEvent(e);
        });

        //Block paste. Typeahead blocked in CISAddressTypeAhead.ts
        $("#ApplicationInformation_EligibilityInfo_BillingNumber").on("paste drop", (e) => {
            $(e.target).prop("title", "Please type an <b>account number</b>. You are not able to copy and paste.");
            var tt = $(e.target).tooltip({ placement: "bottom", html: true, container:"body" }).tooltip("show");
            e.preventDefault()
        });


        $("#ApplicationInformation_EligibilityInfo_BillingNumber").on("blur", function () {
            var e = new Event('icf-eligibility-selected');
            document.dispatchEvent(e);
        });

        $("#ApplicationInformation_EligibilityInfo_ZipCode").on("blur", function () {

            //Add support for meter number later.
            let acctNbr = $("#ApplicationInformation_EligibilityInfo_BillingNumber").val();
            if (acctNbr) {
                var e = new Event('icf-eligibility-selected');
                document.dispatchEvent(e);
            }
        });

    }

    private static ShowHideCustomerLookupFields(lookupType) {
        $("#divBillingNumber").hide();
        $("#divMeterNumber").hide();
        $("#divZipcode").hide();
        $("#divTypeaheadAddress").hide();
        var requireZipcode = $("#ApplicationInformation_EligibilityInfo_RequireZipcode").val()

        switch (lookupType) {
            case "1":
            case "7":
                $("#divBillingNumber").show();
                if (requireZipcode == 'True') {
                    $("#divZipcode").show();
                }

                break;
            case "2":
                $("#divMeterNumber").show();
                if (requireZipcode == 'True') {
                    $("#divZipcode").show();
                }
                break;
            case "4":
            case "6":
                $("#divTypeaheadAddress").show();
                break;
        }
        $("#divEligibility").show();
    }


    private static ResetInputs() {

        $(".icf-typeahead-field").val('');
        $("#ApplicationInformation_EligibilityInfo_SearchStatusId").val('');
        $("#ApplicationInformation_EligibilityInfo_BillingNumber").val('');
        $("#ApplicationInformation_EligibilityInfo_MeterNumber").val('');
        $("#ApplicationInformation_EligibilityInfo_ZipCode").val('');
        $("#ApplicationInformation_EligibilityInfo_MelissaAddressKey").val('');
        $("#ApplicationInformation_EligibilityInfo_ServiceTypeCode").val('0');

        $("#divEligibility").find('.field-validation-error').removeClass('field-validation-error').addClass('field-validation-valid').empty();
    }

}